import React from "react";
import image from "../../Assets/images/spinner.gif";
// import Loader from "react-loader-spinner";
const Loading = ({ show }) =>
  show ? (
    <div class="loadingOverlay">
      <p></p>
    </div>
  ) : null;
export default Loading;
